export const LOWQUOTE_PRIMARY_COLOR = "#45129E"; //purple
export const LOWQUOTE_SECONDARY_COLOR = "#F91EAF"; //pink
export const LOWQUOTE_TERTIARY_COLOR = "#fff"; //white
export const LOWQUOTE_PULSE_COLOR = "#77c970" //vibrant green
export const LOWQUOTE_PRIMARY_LIGHT_COLOR = "#8F71C5" //light purple
export const LOWQUOTE_HIGHLIGHT_COLOR = "#8F71C5" //light purple




